module.exports = __webpack_public_path__ + "img/Fondation-entreprise-B-Braun.e09cfb34.jpg";